import React, { PropsWithChildren } from 'react';

export default function PageTitle({ children }: PropsWithChildren) {
  return <h5 className="font-semibold high-emphasis-text">{children}</h5>;
}
